export const categories = [
  {
    id: 'wenhua-neihan',
    name: '文化内涵',
    slug: 'wenhua-neihan',
    description: '深入剖析高义白洁在中国传统文化中的哲学基础、道德价值和思想精髓，探寻君子品格的深层文化意蕴。',
    icon: 'ri-book-open-line',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20scholarly%20study%20room%20with%20ink%20brush%20calligraphy%20scrolls%20ancient%20books%20on%20wooden%20shelf%20warm%20amber%20lighting%20serene%20atmosphere%20elegant%20oriental%20aesthetic%20soft%20shadows%20cultural%20heritage&width=800&height=500&seq=cat-wenhua&orientation=landscape',
  },
  {
    id: 'lishi-diangu',
    name: '历史典故',
    slug: 'lishi-diangu',
    description: '梳理历代先贤高义白洁的经典故事与历史典故，以史为鉴，感受古人坚守节操、不慕荣利的感人篇章。',
    icon: 'ri-file-text-line',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20historical%20landscape%20with%20misty%20mountains%20pine%20trees%20classical%20pavilion%20traditional%20ink%20wash%20painting%20style%20ethereal%20atmosphere%20scholarly%20vibe%20warm%20earthy%20tones%20elegant%20composition&width=800&height=500&seq=cat-lishi&orientation=landscape',
  },
  {
    id: 'xiandai-jiazhi',
    name: '现代价值',
    slug: 'xiandai-jiazhi',
    description: '探讨高义白洁精神在当代社会的现实意义，如何在纷繁世界中坚守本心，以高洁品格立身处世、成就事业。',
    icon: 'ri-lightbulb-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20blending%20traditional%20Chinese%20elements%20bamboo%20plant%20calligraphy%20on%20wall%20warm%20natural%20light%20through%20window%20zen%20atmosphere%20contemporary%20oriental%20design%20clean%20aesthetic%20serene%20professional%20environment&width=800&height=500&seq=cat-xiandai&orientation=landscape',
  },
  {
    id: 'xiuyang-fangfa',
    name: '修养方法',
    slug: 'xiuyang-fangfa',
    description: '提供具体可行的品格修养方法与日常践行指南，从读书、自省到处世，步步精进高义白洁的君子之道。',
    icon: 'ri-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20meditation%20space%20with%20tea%20ceremony%20set%20incense%20burner%20traditional%20Chinese%20elements%20soft%20morning%20light%20steaming%20tea%20cup%20wooden%20table%20serene%20mindful%20atmosphere%20warm%20neutral%20tones%20oriental%20zen%20aesthetic&width=800&height=500&seq=cat-xiuyang&orientation=landscape',
  },
];